









































































































































































































































































import { defineComponent, ref, useContext, onMounted, useFetch, computed } from '@nuxtjs/composition-api';
import { useHomeBannerData } from '~/components/HomePage/homeBanner';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { SfCarousel, SfLink, SfTabs } from '@storefront-ui/vue';
import { useCache, CacheTagPrefix } from '@vue-storefront/cache';
import { CmsPage } from '~/modules/GraphQL/types';
import { useContent } from '~/composables';
import { useNewGearItems } from '~/components/HomePage/newGearItem';
import { useSweetDeals } from "~/components/HomePage/sweetDeals";
import { useOpenBoxByCategory } from "~/components/HomePage/openBoxItem";
import { useFeaturedProductsByCategory } from '~/components/czar/homeFeaturedProducts/homeFeaturedProducts';
import customProductCard from '~/components/czar/customProductCard/customProductCard.vue';
import customProductCard1 from '~/components/czar/customProductCard/customProductCard1.vue';
import { storeToRefs } from 'pinia';
export default defineComponent({
  name: 'HomePage',
  components: {
    customProductCard,
    customProductCard1,
    SfTabs,
    SfCarousel,
    SfLink,
    SkeletonLoader
  },

  setup() {
    const homeBannerSection = useHomeBannerData();
    const { sliders } = storeToRefs(homeBannerSection);
    const { addTags } = useCache();
    const { loadPage } = useContent();
    const newGearItems = useNewGearItems();
    const { data } = storeToRefs(newGearItems);
    const sweetDealsItems = useSweetDeals();
    const { sweetDealsData } = storeToRefs(sweetDealsItems);
    const usedGearItems = useFeaturedProductsByCategory();
    var queryVariables = { category_id: "1207" };
    usedGearItems.fetchUsedGear(queryVariables);
    const { usedGearData } = storeToRefs(usedGearItems);
    const openBoxItems = useOpenBoxByCategory();
    var queryVariables = { category_id: "1259" };
    openBoxItems.fetchUsedGear(queryVariables);
    const { openBoxData } = storeToRefs(openBoxItems);
    var slider_loading = ref(true);
    const initFun = () => { slider_loading.value = false; }
    const main_categories = [
      {
        "title": "Cameras",
        "url": "/photography/cameras-lenses/digital-cameras.html",
        "custom_class": "Photography-image",
        "__typename": "mainCategories"
      },
      {
        "title": "Lenses",
        "url": "/photography/cameras-lenses/lenses.html",
        "custom_class": "lenses-image",
        "__typename": "mainCategories"
      },
      {
        "title": "Accessories",
        "url": "/photography/accessories.html",
        "custom_class": "Photo-image",
        "__typename": "mainCategories"
      },
      {
        "title": "Lighting",
        "url": "/lighting",
        "custom_class": "lighting-image",
        "__typename": "mainCategories"
      },
      {
        "title": "Used",
        "url": "/shop-used-gear",
        "custom_class": "Used-image",
        "__typename": "mainCategories"
      },
      {
        "title": "Audio",
        "url": "/audio",
        "custom_class": "audio-image",
        "__typename": "mainCategories"
      },
      {
        "title": "Video",
        "url": "/video",
        "custom_class": "Video-image",
        "__typename": "mainCategories"
      },
      {
        "title": "Film",
        "url": "/photography/film-darkroom-supplies/film.html",
        "custom_class": "film-image",
        "__typename": "mainCategories"
      },
      {
        "title": "Printers",
        "url": "/photography/scanning-printing/photo-printers.html",
        "custom_class": "printer-image",
        "__typename": "mainCategories"
      },      
      {
        "title": "Student Kits",
        "url": "/photography/film-darkroom-supplies/student-kits.html",
        "custom_class": "student-kits",
        "__typename": "mainCategories"
      }
    ];

    const page = ref<CmsPage | null>(null);
    useFetch(async () => { page.value = await loadPage({ identifier: 'home' }); });

    onMounted(() => { addTags([{ prefix: CacheTagPrefix.View, value: 'home' }]); });

    const activeTabChanged = (newActiveTab) => {
      const customAttribute = newActiveTab.title;      
      return customAttribute;
    };

    const loading = ref(false);
    const changeTab = (tabNumber: number) => {
      if (tabNumber == 1) {
        loading.value = true;
        if (process.client) {
          setTimeout(function(){
            loading.value = false;
            window.dispatchEvent(new Event('resize'));
          },0.5);
        }
      }
      if (tabNumber == 2) {
        loading.value = true;
        if (process.client) {
          setTimeout(function(){
            loading.value = false;
            window.dispatchEvent(new Event('resize'));
          },0.5);
        }
      }
      if (tabNumber == 3) {
        loading.value = true;
        if (process.client) {
          setTimeout(function(){
            loading.value = false;
            window.dispatchEvent(new Event('resize'));
          },0.5);
        }
      }
      if (tabNumber == 4) {
        loading.value = true;
        if (process.client) {
          setTimeout(function(){
            loading.value = false;
            window.dispatchEvent(new Event('resize'));
          },0.5);
        }
      }
      return tabNumber;
    };
    
    const customactivetab = ref(1);
    const activeTab = computed((tab) => {
      return customactivetab.value;
    });
    const tab_nav_clicked = (tab) => {
      customactivetab.value = tab;
    };

    return {
      customactivetab,
      tab_nav_clicked,
      activeTabChanged,
      changeTab,      
      activeTab,
      page,
      main_categories,
      data,
      sweetDealsData,
      usedGearData,
      openBoxData,
      loading,
      sliders,
      slider_loading,
      initFun
    };
  },
  head() {
    return {
      'title':'Midwest Photo - Capture. Inspire. Share.'
    };
  },
});
